import { z } from 'zod'

/** CosmosRegistrationWireModels at BE 7b23291; the invite contract is separate. */
const startResponseSchema = z.object({
  registrationToken: z.string().refine((value) => value.trim().length > 0),
  otpExpiresAt: z.iso.datetime({ offset: true }),
  tokenExpiresAt: z.iso.datetime({ offset: true }),
})

const verificationResponseSchema = z.object({
  verified: z.boolean(),
  remainingAttempts: z.number().int().nonnegative(),
})

export interface RegistrationDeadlines {
  readonly registrationToken: string
  readonly otpExpiresAt: number
  readonly tokenExpiresAt: number
}

export function parseRegistrationStartResponse(value: unknown, now: number): RegistrationDeadlines | null {
  const parsed = startResponseSchema.safeParse(value)
  if (!parsed.success) return null
  const otpExpiresAt = Date.parse(parsed.data.otpExpiresAt)
  const tokenExpiresAt = Date.parse(parsed.data.tokenExpiresAt)
  if (!Number.isFinite(otpExpiresAt) || !Number.isFinite(tokenExpiresAt) || otpExpiresAt <= now || tokenExpiresAt <= now) return null
  return { registrationToken: parsed.data.registrationToken, otpExpiresAt, tokenExpiresAt }
}

export function parseRegistrationVerificationResponse(value: unknown): z.infer<typeof verificationResponseSchema> | null {
  const parsed = verificationResponseSchema.safeParse(value)
  return parsed.success ? parsed.data : null
}
